import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  mainBackground: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999,
  },
  backgroundContent: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
  },
});

interface LoadingProps {
  customBackgroundColor?: string;
}

export const Loading = ({ customBackgroundColor }: LoadingProps): JSX.Element => {
  const classes = useStyles();

  return (
    <div className={classes.mainBackground}
      style={{
        backgroundColor: customBackgroundColor ?
          customBackgroundColor : "rgba(255,255,255,0.95)"
      }}
    >
      <div className={classes.backgroundContent}>
        <CircularProgress color="secondary" />
      </div>
    </div>
  );
};
